<template>
  <div class="actions is-centered">
    <AppRadialMenu
      :size="36"
      :item-size="48"
      :radius="80"
      :angle-restriction="45"
      :rotate="-22"
    >
      <AppRadialMenuItem
        class="tooltip is-tooltip-info has-background-info has-text-white"
        data-tooltip="Descargar XML"
      >
        <a
          class="action-option"
          @click="download('xml')"
        >
          <BIcon
            icon="cloud-download"
            class="action-option-icon"
          />
          <span class="close-label">
            xml
          </span>
        </a>
      </AppRadialMenuItem>

      <AppRadialMenuItem
        class="tooltip is-tooltip-info has-background-info has-text-white"
        data-tooltip="Descargar PDF"
      >
        <a
          class="action-option"
          @click="download('pdf')"
        >
          <BIcon
            icon="cloud-download"
            class="action-option-icon"
          />
          <span class="close-label">
            pdf
          </span>
        </a>
      </AppRadialMenuItem>
    </AppRadialMenu>
  </div>
</template>

<script>
export default {
  name: 'HistoryStampedActions',
  components: {
    AppRadialMenu: () => import(/* webpackChunkName: "app-radial-menu" */ '../../AppRadialMenu.vue'),
    AppRadialMenuItem: () => import(/* webpackChunkName: "app-radial-menu-item" */ '../../AppRadialMenuItem.vue'),
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    uuid: {
      type: String,
      required: true,
    },
  },
  methods: {
    async download(type) {
      const now = new Date();

      this.$store.commit('ui/addNotification', {
        type: 'info',
        content: 'Descargando...',
        dateTime: now,
      });

      await this.$store.dispatch('invoice/getAsset', { type, uuid: this.id, customerDownload: true });

      this.$store.commit('ui/deleteNotification', now);
    },
  },
};
</script>

<style scoped>
.box.is-centered.confirmation {
  max-width: 400px;
}
</style>
